export default "__VITE_ASSET__B3ZVGb$0__"